/**
 * Gallery image loading utility
 */

/**
 * Generate gallery images from manifest file
 */
export const generateGalleryImagesFromManifest = async (basePath = '/images/portfolio/') => {
  try {
    const response = await fetch(`${basePath}manifest.json`);
    if (!response.ok) {
      throw new Error(`Failed to load manifest: ${response.status}`);
    }
    
    const manifest = await response.json();
    return manifest.images.map((img, index) => {
      // The filename now includes the full path from the manifest
      return {
        id: index + 1,
        src: `${basePath}${img.filename}`,
        alt: img.alt,
        category: img.category,
        size: getRandomSize()
      };
    });
  } catch (error) {
    console.error('Error loading manifest:', error);
    return [];
  }
};

/**
 * Generate only gallery images (excluding before/after images)
 */
export const generateGalleryOnlyImages = async (basePath = '/images/portfolio/') => {
  try {
    const response = await fetch(`${basePath}manifest.json`);
    if (!response.ok) {
      throw new Error(`Failed to load manifest: ${response.status}`);
    }
    
    const manifest = await response.json();
    // Filter only gallery images (not before/after images)
    const galleryImages = manifest.images.filter(img => 
      img.filename.startsWith('gallery/')
    );
    
    return galleryImages.map((img, index) => {
      return {
        id: index + 1,
        src: `${basePath}${img.filename}`,
        alt: img.alt || `Gallery image ${index + 1}`,
        category: img.category,
        size: getRandomSize()
      };
    });
  } catch (error) {
    console.error('Error loading gallery images:', error);
    return [];
  }
};

const getRandomSize = () => {
  const sizes = ['small', 'medium', 'large'];
  return sizes[Math.floor(Math.random() * sizes.length)];
};